import {Params} from '../getConfig'

export const amplifyNovaairStaging: Params = {
  aws_user_pools_id: 'eu-west-1_PuK059YFd',
  aws_cognito_identity_pool_id: '', // Not needed for any partner
  aws_user_pools_web_client_id: '2gvih42uia7vv02kkpu094ki8j',
  oauth_domain: 'novaair-auth-staging.auth.eu-west-1.amazoncognito.com',
  aws_user_files_s3_bucket: '' // Not needed for any partner
}
